// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customSelect {\n  width: 150px;\n  height: 40px;\n  font-size: 14px;\n}\n.customSelect div[class~='ant-select-selector'] {\n  border: none;\n  font-size: 14px;\n  border-radius: 4px !important;\n}\n.customSelectClassName div[class~='ant-select-item-option-content'] {\n  color: #1a1d24;\n  font-size: 14px;\n  line-height: 24px;\n}", ""]);
// Exports
module.exports = exports;
